import { Button, ContentBlock } from 'braid-design-system';

import { METRIC_ERRORS, METRIC_WARNINGS } from 'src/constants/metrics';
import { reportError, reportWarning } from 'src/modules/MetricsReporter';
import Panel from 'src/views/shared/Panel/Panel';

const triggerAllMetrics = () => {
  Object.values(METRIC_ERRORS).map((error) => reportError(error));
  Object.values(METRIC_WARNINGS).map((warning) => reportWarning(warning));
};

const MetricsTestPage = () => (
  <ContentBlock>
    <Panel>
      <Button variant="solid" tone="brandAccent" onClick={triggerAllMetrics}>
        Report metrics
      </Button>
    </Panel>
  </ContentBlock>
);

export default MetricsTestPage;
